module.exports = __webpack_public_path__ + "img/8.882cc61c.jpg";